import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
} from '@ey-xd/motif-react';
import { actionIcInfo24px } from '@ey-xd/motif-react/assets/icons';
import { SUBMISSION_FAILURE_MODAL } from '@constants/commonConstants';
import { BodyContent, HeaderWrapper, ParagraphStyle } from '@organisms/modals/styles/modalStyles';
import { isMobile } from 'react-device-detect';
import '@styles/commonStyles.css';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Submission_Failure } from '@recoil/recoil';

const SubmissionFailureModal = () => {
  const [, setShowSubmissionFailureModal] = useRecoilState(Submission_Failure);
  const showSubmissionFailureModal = useRecoilValue(Submission_Failure);
  const Header = ({ children }) => <HeaderWrapper>{children}</HeaderWrapper>;
  const bodyContent = (
    <BodyContent>
      <p>{SUBMISSION_FAILURE_MODAL.DESCRIPTION}</p>
    </BodyContent>
  );
  const headerTitle = (
    <span style={{ marginLeft: 11, fontSize: 16 }}>{SUBMISSION_FAILURE_MODAL.HEADER_TITLE}</span>
  );

  const refreshPage = () => {
    setShowSubmissionFailureModal(false);
    window.location.reload();
  };

  if (showSubmissionFailureModal) {
    /* Removing rowData from session storage to handle the scenario where the user changes the commit toggle but leaves the browser tab open and the forecast window gets closed. In this case, the retain commit logic should not be triggered. */
    sessionStorage.removeItem('rowData');
  }

  return (
    <>
      <MotifModal
        variant="alt"
        show={showSubmissionFailureModal}
        size={isMobile ? 'sm' : 'md'}
        className={isMobile ? 'motif-Modal-mobile' : null}
        focusTrapOptions={{
          initialFocus: false,
        }}
      >
        <MotifModalHeader closeModalButton={true}>
          <Header>
            <MotifIcon style={{ color: '#FF9831', lineHeight: 1 }} src={actionIcInfo24px} />
            {headerTitle}
          </Header>
        </MotifModalHeader>
        <MotifModalBody>
          <ParagraphStyle> {bodyContent}</ParagraphStyle>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton variant="secondary" type="button" onClick={refreshPage}>
            {SUBMISSION_FAILURE_MODAL.BUTTON_TITLE}
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
};
export default SubmissionFailureModal;
